// @ts-nocheck
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { isValueEmpty } from '../../utils/Utils';
import { NOOP } from '../../const/CommonConst';
import TableSchemaBuilder from '../TableSchemaBuilder/TableSchemaBuilder';
import ConfigColumnTableView from './AttributesForm/FieldComponents/ConfigColumnTableView';

const AdvancedTableViewer = ({ attribute, value, height = '100%' }) => {
  // The all cells are calculated because we are storing cells data in table schema and data can be different. e.g. If someone dose not add anything in the any one of the cell in the table schema and then in model we added data in the cell. So in table schema we did not have that cell registered but in models data we have that cell. So we need to merge the data from both table schema and model cells so we can render all sides cells.
  const allCells = useMemo(() => {
    const keysOfSchemaCells = Object.keys(
      attribute?.advanced_table_schema?.cells || {}
    );
    const keysOfDataSavedInModel = Object.keys(value?.Cells || {});
    return Array.from(
      new Set([...keysOfSchemaCells, ...keysOfDataSavedInModel])
    );
  }, [attribute?.advanced_table_schema?.cells, value?.Cells]);

  const mergedSchema = useMemo(
    () => ({
      ...(attribute?.advanced_table_schema || {}),
      cells: allCells.reduce((acc, cellKey) => {
        const baseCells = attribute?.advanced_table_schema?.cells || {};

        return {
          ...acc,
          [cellKey]: {
            ...(baseCells[cellKey] || {}),
            value: isValueEmpty(value?.Cells?.[cellKey]?.value)
              ? baseCells?.[cellKey]?.value
              : value?.Cells?.[cellKey]?.value,
          },
        };
      }, {}),
    }),
    [attribute?.advanced_table_schema, value, allCells]
  );

  const isConfigColumnMode =
    attribute?.advanced_table_schema?.config_column === true;

  if (isConfigColumnMode) {
    return (
      <Box sx={{ height: height, width: '100%' }}>
        <ConfigColumnTableView
          attribute={attribute}
          value={value}
          onChange={NOOP}
          isViewMode={true}
          configColumn={isConfigColumnMode}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ height: height, width: '100%' }}>
      <TableSchemaBuilder
        initialSchema={mergedSchema}
        tableConfig={{
          showToolbar: false,
          readOnly: true,
          editMode: false,
          showCellPreviewer: false,
        }}
      />
    </Box>
  );
};

AdvancedTableViewer.propTypes = {
  attribute: PropTypes.shape({
    advanced_table_schema: PropTypes.shape({
      cells: PropTypes.shape({}),
      config_column: PropTypes.bool,
    }),
  }).isRequired,
  value: PropTypes.shape({
    Cells: PropTypes.shape({}),
  }).isRequired,
  height: PropTypes.string,
};

export default AdvancedTableViewer;
